import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@everlane/button'
import RouterLink from 'base/components/router_link'
import LoadingAnimation from 'base/react/components/loading_animation'

import Input from 'base/react/components/form/input'

function MagicLinkSignInWithPassword({
  errors,
  initialEmail = '',
  onSubmit,
  onClickSwitchToPasswordless,
  isLoading,
}) {
  const [email, setEmail] = useState(initialEmail)
  const [password, setPassword] = useState('')

  const emailField = () => {
    return (
      <Input
        label="Email"
        error={errors.email}
        placeholder="Enter email address"
        autoComplete="email"
        type="email"
        value={email}
        onChange={event => setEmail(event.target.value)}
      />
    )
  }

  const passwordField = () => {
    return (
      <Input
        label="Password"
        error={errors.password}
        placeholder="Enter password"
        autoComplete="password"
        type="password"
        value={password}
        onChange={event => setPassword(event.target.value)}
      />
    )
  }

  const logInButton = () => {
    return (
      <Button
        className="magic-link-sign-in__flat-button"
        type="submit"
        disabled={isLoading}
        variant="rectangle"
        dark
      >
        {isLoading ? (
          <LoadingAnimation className="magic-link-sign-in__loading-spinner" />
        ) : (
          'Log In'
        )}
      </Button>
    )
  }

  const resetPasswordButton = () => {
    return (
      <div className="magic-link-sign-in__link-wrapper">
        <RouterLink className="magic-link-sign-in__link" href="/reset">
          Reset Password
        </RouterLink>
      </div>
    )
  }

  const bottomCta = () => {
    return (
      <Button
        className="magic-link-sign-in__flat-button"
        onClick={onClickSwitchToPasswordless}
        variant="rectangle"
      >
        Log In Without Password
      </Button>
    )
  }

  return (
    <div className="magic-link-sign-in__wrapper">
      <form
        onSubmit={event => {
          event.preventDefault()
          onSubmit({ email, password })
        }}
      >
        {emailField()}
        {passwordField()}
        {logInButton()}
      </form>
      {resetPasswordButton()}
      <p className="magic-link-sign-in__or">Or</p>
      {bottomCta()}
    </div>
  )
}

MagicLinkSignInWithPassword.propTypes = {
  errors: PropTypes.object,
  initialEmail: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClickSwitchToPasswordless: PropTypes.func.isRequired,
}

export default MagicLinkSignInWithPassword
